import TextInput, { TextInputProps } from 'components/Forms/TextInput/TextInput';
import { createNumberAriaLabel } from 'helpers/accessibility/ariaLabelHelpers';

type PhoneInputProps = Omit<TextInputProps, 'type' | 'inputMode'>;

export const PhoneInput: FC<PhoneInputProps> = (props) => {
    return (
        <TextInput
            {...props}
            aria-label={createNumberAriaLabel(props.fieldRef?.value ?? '')}
            inputMode="tel"
            type="text"
        />
    );
};
